// extracted by mini-css-extract-plugin
module.exports = {"step-text":"step-text__1KVTr","large":"large__1DOJM"};